import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=688975a4&"
import script from "./CardWidget.vue?vue&type=script&lang=js&"
export * from "./CardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688975a4')) {
      api.createRecord('688975a4', component.options)
    } else {
      api.reload('688975a4', component.options)
    }
    module.hot.accept("./CardWidget.vue?vue&type=template&id=688975a4&", function () {
      api.rerender('688975a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardWidget.vue"
export default component.exports